import axios from 'axios';
import config from '../config';
import { store } from '../store';

const METRIC_PATHS = {
  onTrack: 'on-track',
  atRisk: 'at-risk',
  recoverToday: 'recover-today',
  cashOutstanding: 'cash-outstanding',
  expected: 'expected',
  dso: 'dso',
  exposureSummary: 'exposure-summary',
  cashTimingBands: 'cash-timing-bands',
  thisWeek: 'this-week',
  thisWeekAiSummary: 'this-week/ai-summary',
  paymentFriction: 'payment-friction',
  cashImpactSignals: 'cash-impact-signals',
};

const getRequestConfig = (shortCode) => {
  const token = store.getState()?.loginReducer?.token;
  const headers = {};

  if (shortCode) {
    headers['x-organisation'] = shortCode;
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {
    withCredentials: true,
    headers: Object.keys(headers).length ? headers : undefined,
  };
};

const DrmMetricsService = {
  METRIC_PATHS,

  async getMetric({ shortCode, metric }) {
    if (!shortCode) {
      throw new Error('DrmMetricsService.getMetric: shortCode is required');
    }

    const metricPath = METRIC_PATHS[metric];
    if (!metricPath) {
      throw new Error(`DrmMetricsService.getMetric: unsupported metric "${metric}"`);
    }

    const baseUrl = config.drmApiUrl || config.apiUrl;
    const requestConfig = getRequestConfig(shortCode);

    const mountedUrl = `${baseUrl}/metrics/${shortCode}/${metricPath}`;

    const { data } = await axios.get(mountedUrl, requestConfig);
    return data;
  },

  async getFreshness({ shortCode, clientLastRefreshDate }) {
    if (!shortCode) {
      throw new Error('DrmMetricsService.getFreshness: shortCode is required');
    }

    const baseUrl = config.drmApiUrl || config.apiUrl;
    const requestConfig = getRequestConfig(shortCode);
    const params = {};

    if (clientLastRefreshDate) {
      params.clientLastRefreshDate = clientLastRefreshDate;
    }

    const url = `${baseUrl}/metrics/${shortCode}/freshness`;
    const { data } = await axios.get(url, { ...requestConfig, params });
    return data;
  },
};

export default DrmMetricsService;
